// extracted by mini-css-extract-plugin
module.exports = {"downloadButton":"downloadPdfButton_downloadButton__1r206"};